import React from 'react';
import { POS_VIEW_OPTIONS } from '../utils/posSync';

const PosModeTabs = ({ value, onChange, className = '' }) => (
  <div className={`inline-flex rounded-lg border border-gray-200 bg-white p-1 shadow-sm ${className}`.trim()}>
    {POS_VIEW_OPTIONS.map((option) => {
      const isActive = value === option.value;
      return (
        <button
          key={option.value}
          type="button"
          onClick={() => onChange?.(option.value)}
          className={`rounded-md px-3 py-2 text-sm font-semibold transition ${
            isActive
              ? 'bg-blue-600 text-white shadow-sm'
              : 'text-gray-600 hover:bg-gray-100 hover:text-gray-900'
          }`}
        >
          {option.label}
        </button>
      );
    })}
  </div>
);

export default PosModeTabs;
